export const actionTypes = {
  SET_BILLING_AMOUNTS: "PURCHASE:SET_BILLING_AMOUNTS",
  SET_BILLING_REDIRECT: "PURCHASE:SET_BILLING_REDIRECT",

  SET_BALANCE: "PURCHASE:SET_BALANCE",
  SET_BALANCE_LOADING: "PURCHASE:SET_BALANCE_LOADING",
  SET_SOME_PREMIUMS: "PURCHASE:SET_SOME_PREMIUMS",

  SET_PREMIUM_PRICES: "PURCHASE:SET_PREMIUM_PRICES",
  SET_VELVET_CATALOG: "PURCHASE:SET_VELVET_CATALOG",
  SET_TOP_PRICES: "PURCHASE:SET_TOP_PRICES",
  SET_UP_PRICES: "PURCHASE:SET_UP_PRICES",
  SET_HIDDEN_PRICES: "PURCHASE:SET_HIDDEN_PRICES",
  SET_ONLINE_PRICES: "PURCHASE:SET_ONLINE_PRICES",

  SET_CURRENT_BUY: "PURCHASE:SET_CURRENT_BUY",
  SET_BUY_LOADING: "PURCHASE:SET_BUY_LOADING",
  SET_BUY_SUCCESS: "PURCHASE:SET_BUY_SUCCESS",

  SET_BOOSTS: "PURCHASE:SET_BOOSTS",
  REDUCE_BOOSTS: "PURCHASE:REDUCE_BOOSTS",
  SET_BOOST_USED: "PURCHASE:SET_BOOST_USED",

  SET_BONUS_PRICE: "PURCHASE:SET_BONUS_PRICE",
  SET_BONUS_USED: "PURCHASE:SET_BONUS_USED",
};

export type priceType = {
  id: number;
  duration?: number;
  amount: number;
  discount: number;
  bonuses?: Array<string>;
  count?: number;
};

export enum buyTypes {
  premium = 1,
  top = 2,
  hidden = 3,
  online = 4,
  up = 5,
  contact = 6
}

export type currentBuyType = {
  type: buyTypes;
  id: number;
  /** id из каталога Velvet (offerId / packId) — для оплаты картой (Flowguard) */
  catalogId?: string;
  currency?: string;
  days?: number;
  price?: number;
  title: string;
  bonuses?: Array<string>;
}

export type buySuccessType = "Yes" | "No" | "Never"

export type somePremiumsType = {
  hiddenRest: string | null;
  onlineRest: string | null;
  pinnedRest: string | null;
  premiumRest: string | null;
  place?: number | null;
}

export enum bonusBuyNumbers {
  BoostRating = 0,
  PinnedProfile = 1,
  Invisible = 2,
  OnlineFilter = 3, 
  Premium = 4,
  Contact = 5
}